import React, { useState } from 'react';
import { FaPaperPlane } from 'react-icons/fa';

export default function Contact() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    // Simüle edilmiş API çağrısı
    setTimeout(() => {
      setLoading(false);
      setSubscribed(true);
      setEmail('');
    }, 1000);
  };

  return (
    <section className="py-20 bg-[var(--color-background)]">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* İletişim Formu */}
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h2 className="text-3xl font-bold text-[var(--color-primary)] mb-6">Bize Ulaşın</h2>
            <p className="text-lg text-[var(--color-black)] mb-8">
              SolarTools ekibi olarak, sorularınızı yanıtlamaktan ve size özel çözümler sunmaktan memnuniyet duyarız.
            </p>
            <form className="space-y-4">
              <div>
                <input 
                  type="text" 
                  placeholder="Adınız Soyadınız" 
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)] focus:border-transparent"
                />
              </div>
              <div>
                <input 
                  type="email" 
                  placeholder="E-posta Adresiniz" 
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)] focus:border-transparent"
                />
              </div>
              <div>
                <textarea 
                  rows="4" 
                  placeholder="Mesajınız" 
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)] focus:border-transparent"
                ></textarea>
              </div>
              <button 
                type="submit" 
                className="w-full bg-[var(--color-primary)] hover:bg-[var(--color-secondary)] text-white font-semibold py-3 rounded-lg transition-colors duration-300"
              >
                Gönder
              </button>
            </form>
          </div>

          {/* Bülten Kaydı */}
          <div className="text-center lg:text-left">
            <h2 className="text-3xl font-bold text-[var(--color-primary)] mb-6">
              SolarTools Bültenine Kayıt Olun
            </h2>
            <p className="text-lg text-[var(--color-black)] mb-8">
              Güneş enerjisi sektöründeki son gelişmeler, ürün güncellemeleri ve teknik makalelerden haberdar olun.
            </p>
            <form onSubmit={handleSubmit} className="max-w-md mx-auto lg:mx-0">
              <div className="flex gap-2">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="E-posta adresiniz"
                  className="flex-1 px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)] focus:border-transparent"
                  required
                />
                <button
                  type="submit"
                  disabled={loading || subscribed}
                  className={`px-6 py-3 rounded-lg font-semibold flex items-center gap-2 transition-colors duration-300 ${
                    subscribed
                      ? 'bg-green-500 text-white cursor-default'
                      : 'bg-[var(--color-primary)] hover:bg-[var(--color-secondary)] text-white'
                  }`}
                >
                  {loading ? (
                    'Gönderiliyor...'
                  ) : subscribed ? (
                    'Kaydoldunuz!'
                  ) : (
                    <>
                      Kaydol
                      <FaPaperPlane />
                    </>
                  )}
                </button>
              </div>
            </form>
            <p className="text-sm text-gray-500 mt-4">
              Kaydolarak SolarTools'un gizlilik politikasını kabul etmiş olursunuz.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
} 